import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import SEO from "../components/SEO";
import { api } from "../lib/api";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/api/auth/login", { email, password });
      navigate("/admin/inquiries");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SEO title="Admin Login | HAQILA" description="HAQILA admin access." />
      <div data-testid="admin-login-page" className="bg-charcoal min-h-screen pt-40 pb-24 flex items-start justify-center">
        <div className="w-full max-w-md px-5">
          <div className="bg-white/[0.03] border border-white/10 p-8 sm:p-10">
            <Lock className="w-6 h-6 text-clay mb-6" />
            <h1 className="font-display text-3xl font-bold tracking-tight text-offwhite">Admin Access</h1>
            <p className="mt-2 text-sm text-offwhite/50">HAQILA inquiry management.</p>
            <form data-testid="admin-login-form" onSubmit={handleSubmit} className="mt-8 space-y-5">
              <div className="space-y-2">
                <Label className="text-xs font-bold uppercase tracking-[0.18em] text-offwhite/50">Email</Label>
                <Input
                  data-testid="admin-email-input"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="h-12 rounded-none border-white/15 bg-charcoal text-offwhite text-sm focus-visible:ring-clay focus-visible:ring-offset-0"
                  placeholder="admin@haqila.com"
                />
              </div>
              <div className="space-y-2">
                <Label className="text-xs font-bold uppercase tracking-[0.18em] text-offwhite/50">Password</Label>
                <Input
                  data-testid="admin-password-input"
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="h-12 rounded-none border-white/15 bg-charcoal text-offwhite text-sm focus-visible:ring-clay focus-visible:ring-offset-0"
                  placeholder="••••••••••••"
                />
              </div>
              <button
                type="submit"
                data-testid="admin-login-submit"
                disabled={loading}
                className="w-full inline-flex items-center justify-center gap-2 bg-forest hover:bg-moss disabled:opacity-60 text-offwhite font-semibold px-6 py-3.5 text-sm tracking-wide transition-colors duration-300"
              >
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
